import { defineMessages } from 'react-intl';

export default defineMessages({
  summaryHeading: {
    id: 'smart-rate.how-smart-rate-works.adjusts-credits-panel.summary-heading',
    defaultMessage: 'Credit amounts that adjust to demand in real time',
  },
  summaryBodyParagraph1: {
    id: 'smart-rate.how-smart-rate-works.adjusts-credits-panel.summary-body-paragraph-1',
    defaultMessage: 'SmartRate helps you maximize revenue from empty spots by adjusting credit amounts in real time.',
  },
  summaryBodyParagraph2: {
    id: 'smart-rate.how-smart-rate-works.adjusts-credits-panel.summary-body-paragraph-2',
    defaultMessage:
      'This is based on a variety of factors like class popularity, class time, and proximity of booking to class time.',
  },
});
